module.exports = __webpack_public_path__ + "img/img_level_16.e2bb1935.png";